import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { ComplaintsContent } from "../components/complaints-content"

const ComplaintsPage = () => (
  <Layout>
    <SEO title="Complaints Policy" />
    <ComplaintsContent />
  </Layout>
)

export default ComplaintsPage
